import { FormControl } from '@angular/forms';

import * as day from 'dayjs';
import { FlexTimePeriod, IAuthPerson } from 'libs/domain';
import { FlexTimeActivityInstance } from 'libs/domain';

export enum FtmSharedMessages {
  // Activity Card
  REGISTER_BTN = 'Register For Activity',
  CHANGE_BTN = 'Change',
  REGISTERED_LABEL = 'Registered',
  ASSIGNED_LABEL = 'Assigned',
  SEATS_AVAILABLE = 'Seats Available',
  LOCATION = 'Location',
  TEACHER = 'Teacher',

  // Activity Registration
  MODAL_TITLE_REGISTER = 'Activity Registration',
  MODAL_TITLE_ASSIGN = 'Assign Activity',
  MODAL_ERROR_FETCHING_ACTIVITIES = 'There was a problem fetching the activities, please try again',
  PERIOD_FILTER_LABEL = 'FlexTime Period',
  TEACHER_FILTER_LABEL = 'Teacher',
  TEXT_FILTER_LABEL = 'Search by Activity',
  REGISTRATION_ERROR = 'There was a problem registering for this activity, please try again',
  CHANGE_CONFIRM_TITLE = 'Change Activity',
  CHANGE_CONFIRM_DESC = 'Are you sure you want to choose a new activity?',
  CHANGE_CONFIRM_BTN = 'Change',
  CHANGE_ADD_BTN = 'Add',
  CHANGE_REGISTER_BTN = 'Register',
  CHANGE_CLOSE_BTN = 'Cancel',
  EMPTY_PERIODS_TITLE = 'No periods found',
  EMPTY_PERIODS_MESSAGE = 'Upcoming periods will be visible here',
  PERIOD_LOCKED = 'This period is currently not allowing registration',
  PERIOD_PAST_DEADLINE = 'The registration is past dealine for the selected period',

  MODAL_BUTTON_ASSIGN = 'Assign',
  MODAL_BUTTON_REGISTER = 'Register',

  EMPTY_STATE_TITLE = 'No results found',
  EMPTY_STATE_SUBTITLE_REGISTER = 'There are no activities available for register',
  EMPTY_STATE_SUBTITLE_ASSIGN = 'There are no activities available for assignment',
  EMPTY_STATE_SUBTITLE_GENERIC = 'There are no activities available',

  VALIDATE_ASSIGNMENT_MODAL_TITLE = 'This student is already registered to another activity',
  VALIDATE_ASSIGNMENT_MODAL_MESSAGE = 'Would you like to replace their current activity?',
  VALIDATE_ASSIGNMENT_ERROR = 'There was an issue validating the assignment. Please try again',
  VALIDATE_ASSIGNMENT_CONFIRM_BTN = 'Register',
  VALIDATE_ASSIGNMENT_CLOSE_BTN = 'Cancel',

  // Student Scheduler
  REGISTER_LABEL = 'Register',
  STATUS_LABEL = 'Status',
  TEACHER_LABEL = 'Teacher',
  LOCATION_LABEL = 'Location',

  BEFORE_DEADLINE_LABEL = 'Register before',
  AFTER_DEADLINE_LABEL = 'Past deadline',

  // Period Selector Modal
  PERIOD_SELECTOR_MODAL_CANCEL_BTN = 'Cancel',
  PERIOD_SELECTOR_MODAL_SUBMIT_BTN = 'Register',
}

export type ActivitySelectorModalData = {
  periodId?: number;
  currentActivityId?: number;
  teacher?: IAuthPerson;
  startDate?: day.Dayjs;
  endDate?: day.Dayjs;
  showDatePicker?: boolean;
  selectorType?: 'register' | 'assign';
};

export type ActivitySelectorModalResponse = {
  activityInstance?: FlexTimeActivityInstance;
};

export enum ActivityCardFields {
  NAME = 'NAME',
  DESCRIPTION = 'DESCRIPTION',
  TEACHER = 'TEACHER',
  LOCATION = 'LOCATION',
  SEATS = 'SEATS',
}

export type PeriodSelectorModalData = {
  modalTitle: string;
  message?: string;
};

export type PeriodSelectorModalResponse = {
  period?: FlexTimePeriod;
};
